// extracted by mini-css-extract-plugin
export var avatarContainer = "_hb-0";
export var avatarTypingWave = "_hb-i";
export var gray = "_hb-f";
export var green = "_hb-c";
export var icon = "_hb-9";
export var image = "_hb-1";
export var lg = "_hb-6";
export var md = "_hb-5";
export var presenceDot = "_hb-b";
export var red = "_hb-d";
export var sm = "_hb-4";
export var status = "_hb-a";
export var typingDot = "_hb-h";
export var typingPill = "_hb-g";
export var xl = "_hb-7";
export var xs = "_hb-3";
export var xxl = "_hb-8";
export var xxs = "_hb-2";
export var yellow = "_hb-e";